import { NgModule } from "@angular/core";

import { CommonModule, DatePipe } from '@angular/common';
import { CoreCommonModule } from '@core/common.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';

import { DashboardRoutingModule } from "./dashboard-routing.module";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { CyberscoreWidgetComponent } from './dashboard/components/cyberscore-widget/cyberscore-widget.component';
import { CertAlertComponent } from './dashboard/components/cert-alert/cert-alert.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { ImproperWidgetComponent } from "./dashboard/components/improper-widget/improper-widget.component";
import { RiskAnalysisWidgetComponent } from "./dashboard/components/risk-analysis-widget/risk-analysis-widget.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { RecommendedActionsWidgetComponent } from "./dashboard/components/recommended-actions-widget/recommended-actions-widget.component";
import { AmeliorationPointWidgetComponent } from "./dashboard/components/amelioration-point-widget/amelioration-point-widget.component";
import { ProgramListComponent } from "./dashboard/components/program-list/program-list.component";
import { SharedModule } from "app/main/shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// swiper configuration
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    DashboardComponent,
    RiskAnalysisWidgetComponent,
    RecommendedActionsWidgetComponent,
    ImproperWidgetComponent,
    CyberscoreWidgetComponent,
    AmeliorationPointWidgetComponent,
    ProgramListComponent,
    CertAlertComponent
  ],
  imports: [
    NgxSkeletonLoaderModule,
    DashboardRoutingModule,
    TranslateModule,
    CoreCommonModule,
    CommonModule,
    SwiperModule,
    NgApexchartsModule,
    NgSelectModule,
    SwiperModule,
    SharedModule,
    NgbModule
  ],
  exports: [
    ProgramListComponent
  ],
  providers: [
    { provide: SWIPER_CONFIG, useValue: DEFAULT_SWIPER_CONFIG },
    DatePipe
  ]
})
export class DashboardModule { }
